import {register, CloudObject, defineProperty} from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class EPRID extends CloudObject {
    /**
     * Creates an instance of EPRID.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(EPRID);
    }

    /**
     * @return {number}
     */
    getId() {
        return this.get(EPRID.idProp);
    }
}

// Hardcoded tags
register('018c68a430d7e2f22df5', EPRID);
EPRID.idProp = defineProperty('018c68a457e8aa4e243f');
